import { Decoration_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { isMaliciousUrl } from "./../_shared/link/is-malicious-url.js";
import { fromTiptapLinkConverter } from "./../_shared/link/link-converters.js";
const linkConverter = {
  fromPm: {
    type: Decoration_Type.LINK,
    convert: (mark) => {
      const { attrs } = mark;
      return [
        {
          type: Decoration_Type.LINK,
          linkData: {
            ...attrs,
            ...attrs?.link ? { link: fromTiptapLinkConverter(attrs.link) } : {}
          }
        }
      ];
    }
  },
  toPm: {
    type: Decoration_Type.LINK,
    convert: (decoration) => {
      const { linkData } = decoration;
      return isMaliciousUrl(linkData?.link?.url || "") ? void 0 : {
        type: Decoration_Type.LINK,
        attrs: {
          ...linkData
        }
      };
    }
  }
};
export {
  linkConverter
};
//# sourceMappingURL=link-converter.js.map
